import { render, staticRenderFns } from "./t-app-blackout.vue?vue&type=template&id=67253c5a&scoped=true&"
import script from "./t-app-blackout.vue?vue&type=script&lang=js&"
export * from "./t-app-blackout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67253c5a",
  null
  
)

export default component.exports